import { useContext } from 'react';

import type { clientTypes } from '@bedc/client/types';

import { BrandContext } from '../providers/BrandContext';
import type { getBrandLogos } from '../utils/brandLogoUtils';

// ----------------------------------------------------------------------------
// TYPES
// ----------------------------------------------------------------------------

export namespace useBrand {
	export type Return = {
		/** Active identity and resolved application logo assets. */
		brand: { id: clientTypes.brand.Id } & clientTypes.brand.Profile &
			ReturnType<typeof getBrandLogos>;
		/** Select an in-memory brand independently of access scope. */
		setBrand: (id: clientTypes.brand.Id) => void;
		/** Restore the initially delivered brand. */
		resetBrand: () => void;
	};
}

// ----------------------------------------------------------------------------
// HOOKS
// ----------------------------------------------------------------------------

export const useBrand = (): useBrand.Return => {
	'use memo';

	// Data
	// ------------------------------------------------------------------------

	const value = useContext(BrandContext);
	if (!value) throw new Error('useBrand requires BrandProvider');

	// Return
	// ------------------------------------------------------------------------

	return value;
};
